import { useLoad } from "@allergy123/api-client/react";
import { useAuth } from "@allergy123/auth-client/react";
import { Button, Container, DraftBanner, SiteFooter, SiteHeader } from "@allergy123/ui";
import type { ReactNode } from "react";
import { NavLink } from "react-router";
import { currentPersonaKey, personas, setPersona, type PersonaKey } from "./personas";

const dev = import.meta.env.MODE !== "production";

export function AppShell({ children }: { children: ReactNode }) {
  const { session, signOut } = useAuth();
  const me = useLoad((api) => api.me());
  const canSeePractice = me.data?.memberships.some((m) => m.role === "owner" || m.role === "admin" || m.permissions.includes("learning:assign"));
  const link = (to: string, label: string) => (
    <NavLink to={to} className={({ isActive }) => (isActive ? "font-semibold text-anchor" : undefined)} end={to === "/"}>
      {label}
    </NavLink>
  );
  return (
    <div className="min-h-screen bg-canvas">
      {dev && (
        <DraftBanner>
          Development build — synthetic sign-in as{" "}
          <select aria-label="Sign in as" className="rounded-sm border border-rule-strong bg-card px-1 py-0.5 text-small" value={currentPersonaKey()} onChange={(e) => setPersona(e.target.value as PersonaKey)}>
            {Object.entries(personas).map(([k, p]) => (
              <option key={k} value={k}>
                {p.name}
              </option>
            ))}
          </select>
        </DraftBanner>
      )}
      <SiteHeader
        logoVariant="auto"
        nav={
          <>
            {link("/", "My learning")}
            {link("/training", "Training")}
            {link("/records", "Records")}
            {canSeePractice && link("/practice", "Practice")}
          </>
        }
        actions={
          <>
            <NavLink to="/account" className="text-small text-ink-secondary">
              {session?.claims.email}
            </NavLink>
            <Button variant="secondary" onClick={() => void signOut()}>
              Sign out
            </Button>
          </>
        }
      />
      <main>
        <Container className="py-12">{children}</Container>
      </main>
      <SiteFooter />
    </div>
  );
}
